import { render } from "./CardPreview.vue?vue&type=template&id=ccbb0a1c&scoped=true"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"

import "./CardPreview.vue?vue&type=style&index=0&id=ccbb0a1c&lang=scss&scoped=true"

import exportComponent from "/var/www/legalculture.ru/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbb0a1c"]])

export default __exports__